import { BezierEdge, EdgeLabelRenderer, EdgeProps, getBezierPath } from 'reactflow';
import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { useCallsMenu } from '../CallsMenuContext';

const Edge = (props: EdgeProps) => {
  const { sourceX, sourceY, targetX, targetY } = props;
  const { onDeleteEdge } = useCallsMenu();
  const [_, labelX, labelY] = getBezierPath({ sourceX, sourceY, targetX, targetY });

  return (
    <>
      <BezierEdge {...props} targetX={props.targetX - 1} />
      <EdgeLabelRenderer>
        <IconButton
          sx={{
            '&:hover': {
              backgroundColor: (theme) => theme.palette.error.dark,
            },
            backgroundColor: (theme) => theme.palette.error.main,
            position: 'absolute',
            width: 18,
            height: 18,
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
          color="error"
          size="small"
          className="nodrag nopan"
          onClick={() => onDeleteEdge(props.id)}
        >
          <Close
            sx={{
              fontSize: 14,
              stroke: 'white',
            }}
            htmlColor="white"
          />
        </IconButton>
      </EdgeLabelRenderer>
    </>
  );
};

export default Edge;
